import LoginModal from "./loginModal.svelte";
import PayModal, {payPrice} from "./payModal.svelte";
import WithdrawModal from "./withdrawModal.svelte";

export function loginModal(){
	const modal = new LoginModal({
		target: document.body,
		props:{
			login:true, register:false
		}
	});
}

export function registerModal(){
	const modal = new LoginModal({
		target: document.body,
		props:{
			register:true, login:false
		}
	});
}

export function payModal(sum = 15){
	const modal = new PayModal({
		target: document.body,
		props:{payPrice:sum}
	});
}

export function withdrawModal(){
	const modal = new WithdrawModal({
		target: document.body,
		props:{}
	});
}